<google-map height="100%" width="100%" [center]="center" [zoom]="10">
    <map-marker #mapMarker="mapMarker" *ngFor="let marker of markers" [position]="marker.position"
        [label]="marker.labelStyle" [title]="marker.title" [options]="marker.options"
        (mapClick)="onMarkerClick(mapMarker,marker)">
    </map-marker>

    <map-info-window #infoWindow>
        <div class="info-window-title">
            {{ selectedMarker?.title }}
        </div>
        <div class="info-window-description">
            {{ selectedMarker?.description }}
        </div>
    </map-info-window>

</google-map>